import { render } from "./accessControll.vue?vue&type=template&id=6035a600"
import script from "./accessControll.vue?vue&type=script&lang=js"
export * from "./accessControll.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__